'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blocks = require('../../blocks');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tag(_ref) {
  var children = _ref.children,
      id = _ref.id,
      onClickClose = _ref.onClickClose;

  return _react2.default.createElement(
    _blocks.Tag,
    null,
    _react2.default.createElement(
      _blocks.Tag.Text,
      null,
      children
    ),
    _react2.default.createElement(
      _blocks.Tag.CloseButton,
      { onClick: function onClick() {
          return onClickClose(id);
        } },
      _react2.default.createElement(_blocks.Tag.CloseButtonIcon, null)
    )
  );
}

Tag.propTypes = {
  children: _propTypes2.default.node.isRequired,
  id: _propTypes2.default.string.isRequired,
  onClickClose: _propTypes2.default.func.isRequired
};

exports.default = Tag;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/Tag/index.js
// module id = 1694
// module chunks = 2